// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__7zSA9","tabInner":"styles_tabInner__ctAol"};